(function() {
    'use strict';

    angular.module('allegro').controller('AllegroCodReceiverCreateController', AllegroCodReceiverCreateController);

    AllegroCodReceiverCreateController.$inject = [
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroCodReceiversDataSrvc',
        'allegroCodReceiverMessagesConst'
    ];

    function AllegroCodReceiverCreateController(
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroCodReceiversDataSrvc,
        allegroCodReceiverMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            account: [],
            name: [],
            iban: []
        };

        self.account = {};
        self.receiverData = {
            account: null,
            name: '',
            iban: '',
        };

        self.getAccount = getAccount;
        self.createReceiver = createReceiver;
        self.cleanErrors = cleanErrors;

        active();

        function active(){
            self.getAccount($stateParams.pk);
        }

        function getAccount(accountPk) {
            self.loading = true;

            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function createReceiver() {
            self.receiverData.account = self.account.pk;

            allegroCodReceiversDataSrvc.create(self.receiverData)
                .$promise
                .then(function(response) {
                    notificationSrvc.notification("success", allegroCodReceiverMessagesConst.add);
                    $state.go('layout.allegro-accounts.detail.settings', {pk: self.account.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
